import { Injectable } from '@angular/core';
import { CityStreetEnGbInterface } from '@app/core/interfaces/city-street.en-gb.interface';
import * as addressActions from '@app/store/my-zone/address/address.actions';
import { AddressService } from '@app/store/my-zone/address/address.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class AddressEffects {

     getAddress$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(addressActions.LOAD_ADDRESS),
        switchMap((action: addressActions.LoadAddress) => {
            return this.addressService
                .getCityStreet(action.payload.address.postal_code, action.payload.address.civic_number);
        }),
        map((address: CityStreetEnGbInterface) => new addressActions.LoadAddressSuccess({ address })),
        catchError((errors) => of(new addressActions.LoadAddressError({ errors }))),
    ));

    constructor(
        private actions$: Actions,
        private addressService: AddressService,
    ) {}
}
